'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest from "./presto.-Agent-View$-Upload-File-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$UploadFileRequest$() {
}
export { $c_Lpresto_AgentView$UploadFileRequest$ as $c_Lpresto_AgentView$UploadFileRequest$ };
$p = $c_Lpresto_AgentView$UploadFileRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$UploadFileRequest$;
/** @constructor */
function $h_Lpresto_AgentView$UploadFileRequest$() {
}
export { $h_Lpresto_AgentView$UploadFileRequest$ as $h_Lpresto_AgentView$UploadFileRequest$ };
$h_Lpresto_AgentView$UploadFileRequest$.prototype = $p;
$p.l = (function() {
  return "UploadFileRequest";
});
$p.cFo = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dUpload$002dFile$002dRequest.$c_Lpresto_AgentView$UploadFileRequest(x$0.j(0), x$0.j(1));
});
var $d_Lpresto_AgentView$UploadFileRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$UploadFileRequest$, "presto.AgentView$UploadFileRequest$", ({
  En: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$UploadFileRequest$ as $d_Lpresto_AgentView$UploadFileRequest$ };
var $n_Lpresto_AgentView$UploadFileRequest$;
function $m_Lpresto_AgentView$UploadFileRequest$() {
  if ((!$n_Lpresto_AgentView$UploadFileRequest$)) {
    $n_Lpresto_AgentView$UploadFileRequest$ = new $c_Lpresto_AgentView$UploadFileRequest$();
  }
  return $n_Lpresto_AgentView$UploadFileRequest$;
}
export { $m_Lpresto_AgentView$UploadFileRequest$ as $m_Lpresto_AgentView$UploadFileRequest$ };
//# sourceMappingURL=presto.-Agent-View$-Upload-File-Request$.js.map
